import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@lciapps/auth';
import { ProtectedComponent } from './protected/protected.component';
import { AuthCallbackComponent } from './root/auth-callback.component';
import { HomeComponent } from './root/home/home.component';
import { MemberGuard } from './root/member.guard';
import { NonMemberComponent } from './root/non-member.component';
import { RootComponent } from './root/root.component';
import { SignoutComponent } from './root/signout.component';
import { SsoSamlComponent } from './root/sso-saml.component';

const routes: Routes = [
  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },
  {
    path: 'sso-saml',
    component: SsoSamlComponent
  },
  {
    path: 'signout',
    component: SignoutComponent
  },
  {
    path: 'nonmember',
    canActivate: [AuthGuard],
    component: NonMemberComponent
  },
  {
    path: '',
    component: RootComponent,
    canActivate: [AuthGuard, MemberGuard],
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'activities',
        loadChildren: './features/activities/activities.module#ActivitiesModule'
      },
      {
        path: 'protected',
        component: ProtectedComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
